import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useUpdateCheck } from "@hooks/versionCheck";
import styles from "./VersionCheck.module.scss";
import { CustomModal } from "@components/Modals";
import clsx from "clsx";
import { Button } from "@components/Form";

const UpdateStatus = {
    checking: "checking",
    current: "current",
    available: "available",
};

const VersionCheck = () => {
    const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);
    const location = useLocation();
    const setTimer = useRef(null);
    const { t } = useTranslation();

    const { status, checkUpdate, reloadPage } = useUpdateCheck({
        type: "manual",
    });

    const checkVersion = () => {
        if (setTimer.current === null) {
            checkUpdate();
            setTimer.current = setTimeout(() => {
                clearTimeout(setTimer.current);
                setTimer.current = null;
            }, 30000); // 30 seconds
        }
    };

    useEffect(() => {
        if (status !== UpdateStatus.available) {
            checkVersion();
        }
    }, [location.pathname]);

    useEffect(() => {
        if (status === UpdateStatus.available) {
            setIsNewVersionAvailable(true);
        }
    }, [status]);

    const handleReloadPage = () => {
        setIsNewVersionAvailable(false);
        window.location.reload();
    };

    return (
        <CustomModal
            openModal={isNewVersionAvailable}
            setOpenModal={handleReloadPage}
            className={clsx("bg-milk rounded-xl p-10", styles.versionModal)}
            hideCloseButton
        >
            <div className="text-center">
                <span className="font-bold-poppins text-3xl leading-title text-dawn-gray tracking-tight">
                    {t("common.updateAvailable")}
                </span>
            </div>
            <div className="text-center py-4">
                <span className="font-medium-poppins text-xl text-dawn-gray py-4">
                    {t("common.updateAvailableDescription")}
                </span>
            </div>
            <div className="flex flex-wrap justify-center py-2">
                <Button
                    className={clsx(
                        "rounded-full flex justify-center items-center w-52 py-3 bg-primary"
                    )}
                    onClick={handleReloadPage}
                >
                    <span className="text-white font-semibold tracking-tight">
                        {t("common.refresh")}
                    </span>
                </Button>
            </div>
        </CustomModal>
    );
};

export default VersionCheck;